export const FetchCategoriesCustomAttributes = async ({selectedProjectId, categoryId, accessToken}) => {
    // console.log('FetchCategoriesCustomAttributes params:', selectedProjectId, categoryId, accessToken);

    const requestHeaders = new Headers({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
    });

    const request = new Request(`https://developer.api.autodesk.com/construction/assets/v1/projects/${selectedProjectId}/categories/${categoryId}/custom-attributes?includeInherited=true`, {
        method: 'GET',
        headers: requestHeaders
    });

    try {
        const response = await fetch(request);
        // console.log('Response categories:', response);

        if (!response.ok) {
            throw new Error(`HTTP error from fetching categories! Status: ${response.status} ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};
